<template>
  <div class="DevicesNode">
    <div class="DevicesNode-node lxn-w100 lxn-border-round lxn-overflow-hidden">
      <div :style="labelStyle" :class="$store.getters.language.floatClass" class="DevicesNode-right-label lxn-margin-left-5 lxn-h100">
      </div>
        <div v-if="node.isPaired" :class="$store.getters.language.floatClass" class="DevicesNode-icon" @click="toggleShowInputOutputs">
          <ButtonIcon :size="40" bgColor="#53636C" :icon="showInputOutputsButtonIcon" iconColor="#FFFFFF" :padding="8" />
        </div>
        <div v-else :class="$store.getters.language.floatClass" class="DevicesNode-icon">
          <ButtonIcon :size="40" bgColor="#53636C" icon="notPaired" iconColor="#FFFFFF" :padding="8" :isRound="true" />
        </div>
      <div :class="[$store.getters.language.floatClass, $store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.font]" class="DevicesNode-name lxn-overflow-hidden">
        <span v-if="showHubInfo" class="lxn-text">
          {{hub.name}} > {{name}}
        </span>
        <span v-else class="lxn-text">
          {{name}}
        </span>
      </div>
      <div :class="$store.getters.language.floatClassReverse" class="DevicesNode-button">
        <div v-if="node.isPaired" @click="$router.push('/node' + node.deviceType + 'Settings/' + node.uuid)">
          <ButtonIcon :size="40" bgColor="#1EA5DE" icon="cog" iconColor="#FFFFFF" :padding="8" />
        </div>
        <div v-else @click="$router.push('/pairNode/' + node.uuid)">
          <ButtonIcon :size="40" bgColor="#1EA5DE" icon="pair" iconColor="#FFFFFF" :padding="8" />
        </div>
      </div>
    </div>
    <div v-show="showInputOutputs" class="DevicesNode-wrapper-nodeInputOutputs lxn-margin-auto">
      <NodeInput v-for="(nodeInput, nodeInputIndex) in node.inputs" :key="'nodeInput' + nodeInputIndex" :nodeIndex="index" :index="nodeInputIndex" />
      <NodeOutput v-for="(nodeOutput, nodeOutputIndex) in node.outputs" :key="'nodeOutput' + nodeOutputIndex" :nodeIndex="index" :index="nodeOutputIndex" />
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import NodeInput from '@/components/Home/Devices/NodeInput.vue'
import NodeOutput from '@/components/Home/Devices/NodeOutput.vue'

export default {
  name: 'Node',
  props: {
    index: Number,
    showHubInfo: Boolean
  },
  components: {
    ButtonIcon,
    NodeInput,
    NodeOutput
  },
  data: function () {
    return {
      showInputOutputs: false,
    }
  },
  computed: {
    labelStyle: function() {
      return "background-color: " + this.color;
    },
    node: function() {
      return this.$store.state.nodes[this.index];
    },
    showInputOutputsButtonIcon: function () {
      return this.showInputOutputs ? 'up' : 'down';
    },
    name: function() {
      return this.node.name;
    },
    hub: function() {
      var returnValue = null;
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        if(this.$store.state.hubs[i].id === this.node.hubId){
          returnValue = this.$store.state.hubs[i];
        }
      }
      return returnValue;
    },
    color: function() {
      return this.$store.state.themeMainColors[this.node.color];
    },
    icon: function() {
      return this.node.icon;
    }
  },
  methods: {
    toggleShowInputOutputs: function() {
      this.showInputOutputs = !this.showInputOutputs;
    }
  }
}
</script>

<style>
  .DevicesNode {
    margin-bottom: 10px;
  }
  .DevicesNode:last-child {
    margin-bottom: 0;
  }
  .DevicesNode-node {
    height: 50px;
    background-color: #ECECEC;
  }
  .DevicesNode-right-label {
    width: 8px;
  }
  .DevicesNode-icon {
    margin-left: 5px;
    padding-top: 5px;
  }
  .DevicesNode-name {
    line-height: 50px;
    width: calc(100% - 103px);
  }
  .DevicesNode-button {
    width: 40px;
    margin-top: 5px;
    margin-left: 5px;
  }
  .DevicesNode-wrapper-nodeInputOutputs {
    padding-left: 14px;
    padding-right: 14px;
  }
</style>
